import { notify } from "@pallet-hq/hegel"
import {
    CardNumberElement,
    Elements,
    useElements,
    useStripe,
} from "@stripe/react-stripe-js"
import { CreatePaymentMethodCardData, loadStripe } from "@stripe/stripe-js"
import config from "config"
import { Formik, FormikValues } from "formik"
import * as Yup from "yup"
import { ReactNode } from "react"
import { CreatePaymentMethodForm } from "./Form"

const stripePromise = loadStripe(config.STRIPE_KEY_PUBLIC)

const CreatePaymentMethodComponent = ({
    children,
}: {
    children: ReactNode
}) => {
    const stripe = useStripe()
    const elements = useElements()

    const addCard = async (values: FormikValues) => {
        const paymentData: CreatePaymentMethodCardData = {
            type: "card",
            card: elements?.getElement(CardNumberElement)!,
            billing_details: {
                name: values.nameOnCard,
                email: values.email,
                address: {
                    postal_code: values.postalCode,
                },
            },
        }
        const resp = await stripe?.createPaymentMethod(paymentData)
        if (resp?.paymentMethod?.id) {
            return resp.paymentMethod.id
        } else if (resp?.error?.message) {
            notify.fail(resp.error.message)
        } else {
            notify.fail("Failed to create payment method")
        }
        return null
    }

    return (
        <Formik
            initialValues={{
                nameOnCard: "",
                postalCode: "",
            }}
            onSubmit={addCard}
            validationSchema={Yup.object().shape({
                nameOnCard: Yup.string().required("Required"),
                postalCode: Yup.string().required("Required"),
            })}
            validateOnMount
            enableReinitialize
        >
            {children}
        </Formik>
    )
}

const CreatePaymentMethod = ({ children }: { children: ReactNode }) => (
    <Elements
        stripe={stripePromise}
        options={{
            fonts: [
                {
                    family: "OldschoolGrotesk",
                    src: "url(https://cardea.imgix.net/media/fonts/OldschoolGrotesk/Regular.woff2)",
                    weight: "400",
                },
            ],
        }}
    >
        <CreatePaymentMethodComponent>{children}</CreatePaymentMethodComponent>
    </Elements>
)

export { CreatePaymentMethod, CreatePaymentMethodForm }
